export default "__VITE_ASSET__BbUHzB1K__"